import React from 'react';

const NotificationModuleFormModal = React.lazy(() => import('../components/FormModal'));
const notificationModuleModalRegistry = {
    notification_notificationModuleId: NotificationModuleFormModal
};
export default notificationModuleModalRegistry;
